'use strict';

import escape from 'escape-html'

const defaultOptions = ['COURTIER IMMOBILIER RÉSIDENTIEL', 'title 2', 'title 3']

export class SelectControl {
  constructor(element) {
    this.$control = document.createElement('div')
    this.$control.classList.add('si_controls__control')
    this.$control.classList.add('si_control')
    this.$control.classList.add('si_control--select')

    const $label = document.createElement('label')
    $label.classList.add(`si_control__label`)
    $label.innerHTML = 'Select'


    this.$input = document.createElement('select')
    this.$input.classList.add('si_control__input')
    this.$input.classList.add('si_input')
    this.$input.classList.add('si_input--select')

    this.options = element.attr('si:has-options') ? element.attr('si:has-options').split(';') : defaultOptions

    this.options.forEach((option) => {
      const $option = document.createElement('option')
      $option.classList.add('si_option')
      $option.classList.add('si_input__option')
      $option.innerHTML = option
      this.$input.appendChild($option)
    })


    this.origValue = escape(element.node.innerHTML)
    this.setValue(this.origValue)


    this.$input.addEventListener('input', (e) => {
      element.node.innerHTML = escape(e.target.value)
    })

    element.node.addEventListener('click', () => {
      this.$input.focus()
    })

    this.$control.appendChild($label)
    $label.appendChild(this.$input)

    this.reset = this.reset.bind(this, element)

    return this
  }

  getElement() {
    return this.$control
  }

  setValue(value) {
    this.$input.value = value
    return this
  }

  getValue() {
    return this.$input.value
  }

  reset(element) {
    element.node.innerHTML = this.origValue
    this.setValue(this.origValue)
  }
}
